import Vue from 'vue'
import axios from 'axios'
import router from '@/router'
import qs from 'qs'
import * as Sentry from '@sentry/browser'

const instance = axios.create({
  baseURL: `${process.env.VUE_APP_CORE_URL}/api/Gas`
})
instance.defaults.paramsSerializer = params => {
  return qs.stringify(params, { arrayFormat: 'repeat' })
}
instance.interceptors.request.use(
  reqConfig => {
    if (Vue.prototype.$getCookie('comLoginToken')) {
      const xCorrelationId = Vue.prototype.$getGuid()
      reqConfig.headers = {
        KingnetAuth: 'Cookies ' + Vue.prototype.$getCookie('comLoginToken').split('token=').pop(),
        'X-Correlation-Id': xCorrelationId
      }
      Sentry.setTag('X-Correlation-Id', xCorrelationId)
      return reqConfig
    } else {
      Vue.prototype.$alert('請重新登入', '警告', {
        confirmButtonText: '確定',
        type: 'warning',
        showClose: false,
        roundButton: true,
        closeOnClickModal: false
      }).then(() => {
        router.push({ name: 'LoginMain' })
      })
    }
  },
  err => {
    return Promise.reject(err)
  }
)
instance.interceptors.response.use(
  res => res,
  err => {
    // eslint-disable-next-line eqeqeq
    if (err && err.response && (err.response.status == 401 || err.response.status == 403)) {
      if (err.response.data.Message !== undefined) {
        Vue.prototype.$alert(`${err.response.data.Message}`, '警告', {
          confirmButtonText: '確定',
          type: 'warning',
          showClose: false,
          roundButton: true,
          closeOnClickModal: false
        }).then(() => {
          // eslint-disable-next-line eqeqeq
          if (err.response.status == 401) { router.push({ name: 'LoginMain' }) } else if (err.response.status == 403) { Vue.prototype.$toMainPage() }
        })
        return Promise.reject(err)
      }
    } else if (err && err.response && err.response.status === 409 || err.response.status === 404) {
      Vue.prototype.$alert(err.response.data.ErrorMessage.Description, '警告', {
        confirmButtonText: '確定',
        type: 'warning',
        showClose: false,
        roundButton: true,
        closeOnClickModal: false
      }).then(() => {
        // eslint-disable-next-line eqeqeq
        if (err.response.status == 404) { router.push({ name: 'LoginMain' }) }
      })
      return Promise.reject(err)
    }
  }
)

// Swagger: https://local.kingnetsmart.com.tw/core/index.html#/Gas
export const apiGas = {
  // 列表頁
  List: {
    // 瓦斯登記列表，10行為一單位做載入
    GetGasList: (requestData, config) => instance.get('', Object.assign({}, { params: requestData }, config)),
    // 新增後送出 新的期別（登記年月）
    PostGasInsertPeriod: (requestData, config) => instance.post('', requestData, config),
    // 編輯後送出 更新期別（登記年月）
    PostGasUpdatePeriod: (queryPath, requestData, config) => instance.put(`/${queryPath.id}`, requestData, config),
    // 刪除期別
    DeleteGas: (queryPath, config) => instance.delete(`/${queryPath.id}`, config),
    // 取得當期期別
    GetCurrentGas: (config) => instance.get('/Current', config),
    // 再通知提醒繳費
    NotifyFromRemind: (queryPath, config) => instance.post(`/Notify/${queryPath.id}/Remind`, config)
  },
  // 總覽頁
  OverView: {
    // 取得總覽頁列表內容，一次載入全部戶別
    GetGasList: (queryPath, config) => instance.get(`/${queryPath.gId}`, config),
    // 送出本次度數
    PutGasExport: (queryPath, requestData, config) => instance.put(`/${queryPath.gasId}/Tablet/${queryPath.tabletId}`, requestData, config),
    // 匯出瓦斯抄表總覽頁
    GetGasExport: (queryPath, config) => instance.post(`/${queryPath.gId}/Export`, null, config)
  }
}
